/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TeamModelListResult } from '../../models/team-model-list-result';

export interface ApiTeamTeamsGet$Any$Params {
  ConferenceIds?: Array<number>;
}

export function apiTeamTeamsGet$Any(http: HttpClient, rootUrl: string, params?: ApiTeamTeamsGet$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<TeamModelListResult>> {
  const rb = new RequestBuilder(rootUrl, apiTeamTeamsGet$Any.PATH, 'get');
  if (params) {
    rb.query('ConferenceIds', params.ConferenceIds, {});
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: 'application/octet-stream', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TeamModelListResult>;
    })
  );
}

apiTeamTeamsGet$Any.PATH = '/api/team/teams';
